import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Login.css";
import Avtar from "./img/avatar.svg";
import Bg from "./img/bg.svg";
import WaveImg from "./img/wave.png";
import PersonIcon from "@mui/icons-material/Person";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Box, Alert } from "@mui/material";
import { MAIN_URL } from "../../data/const";

// Request Reset Password Form Component
export const RequestResetPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState({ type: "", message: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await axios.post(
        `${MAIN_URL}/api/v1/himraahi/request-reset`,
        { email }
      );
      setStatus({
        type: "success",
        message:
          "If an account exists with this email, you will receive a password reset link.",
      });
      setTimeout(() => navigate("/login"), 3000);
    } catch (error) {
      setStatus({
        type: "error",
        message:
          error.response?.data?.message ||
          "An error occurred. Please try again.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <img className="wave" src={WaveImg} alt="background wave" />
      <div className="container">
        <div className="img">
          <img src={Bg} alt="background decoration" />
        </div>
        <div className="login-content">
          <form onSubmit={handleSubmit} className="auth-form">
            <img src={Avtar} alt="avatar" className="auth-avatar" />
            <h2 className="title">Reset Password</h2>

            {status.message && (
              <Box mb={2}>
                <Alert
                  severity={status.type}
                  icon={
                    status.type === "success" ? (
                      <CheckCircleIcon />
                    ) : (
                      <ErrorIcon />
                    )
                  }
                >
                  {status.message}
                </Alert>
              </Box>
            )}

            <div className="input-div one">
              <div className="i">
                <PersonIcon className="input-icon" />
              </div>
              <div className="div">
                <input
                  placeholder="Enter your email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="input"
                  disabled={isLoading}
                  required
                />
              </div>
            </div>

            <button
              type="submit"
              className={`btn ${isLoading ? "loading" : ""}`}
              disabled={isLoading}
            >
              {isLoading ? "Sending Reset Link..." : "Send Reset Link"}
            </button>

            <div className="additional-links">
              <a href="/login" className="auth-link">
                Back to Login
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
